/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  title: {
    fontSize: '1rem',
    fontWeight: '500',
  },
});

function UserDetailsInfo({ firstName, lastName, email, userName }) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.title} color="textSecondary" gutterBottom>
            {t('user-management.first-name')}
          </Typography>
          <Typography variant="h5" component="h3">
            {firstName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.title} color="textSecondary" gutterBottom>
            {t('user-management.last-name')}
          </Typography>
          <Typography variant="h5" component="h3">
            {lastName}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.title} color="textSecondary" gutterBottom>
            {t('user-management.user-email')}
          </Typography>
          <Typography variant="h5" component="h3">
            {email}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.title} color="textSecondary" gutterBottom>
            {t('user-management.user-name-profile')}
          </Typography>
          <Typography variant="h5" component="h3">
            {userName}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

export default UserDetailsInfo;
